module.exports = __webpack_public_path__ + "static/img/case_detail_05_1.e1a7bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_05_1.png
// module id = +EHK
// module chunks = 34